<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
    class="for-nav-draw"
    :mini-variant.sync="miniM"
    mini-variant-width="150px"
    permanent
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-list dense nav style="margin-top: 20px">
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
          style="margin-left: 5px; cursor: pointer"
          @click="redirectToHome"
        >
          <v-img :src="require('@/assets/navLogo.jpg')" max-height="30" />
        </v-list-item-avatar>

        <v-list-item-content style="margin-left: 30px">
          <v-list-item-title style="font-size: 30px" v-text="profile.title" />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list expand nav dense>
      <!-- {{authRolePermissionData.role_permission}} -->
      <!-- {{getPermissionMenuData.role_permission}} -->
      <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-view-dashboard-variant</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                Dashboard
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in dashboard" :key="i">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
              >
              </base-item-group>
              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <template v-for="(parentMenu, index) in getPermissionMenuData.role_permission">
        <v-expansion-panels :key="index">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-tooltip right z-index="15">
                <template v-slot:activator="{on,attr}">
                  <v-icon v-on="on" v-bind="attr">
                    {{parentMenu.icon}}
                  </v-icon>
                </template>
                <span style="display: block">{{parentMenu.permission_name}}</span>
              </v-tooltip>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                {{parentMenu.permission_name}}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="({permission_name: title, icon, path: to, add, edit, get, delete: del, role_id, is_menu}, i) in parentMenu.child" :key="i">
              <div v-if="role_id == getUserType.role_id && is_menu=='1' && icon!=null">
                <base-item-group
                  v-if="{title, icon, to, add, edit, get, del}.children"
                  :key="`group-${i}`"
                  :item="{title, icon, to, add, edit, get, del}"
                >
                </base-item-group>
                <base-item v-else :key="`item-${i}`" :item="{title, icon, to, add, edit, get, del}" />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <!-- <template>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-view-dashboard-variant</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                Dashboard
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in dashboard">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
              >
              </base-item-group>
              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-library</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                E-Library
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in eLibrary">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
                id="loki"
              >
              </base-item-group>

              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-content-save-outline</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                E-Content
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in items">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
              >
              </base-item-group>

              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-door-open</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                Portal
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in portal">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
              >
              </base-item-group>

              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-cog</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                Settings
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in settings">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
              >
              </base-item-group>

              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-school</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                Institute
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in institute">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
              >
              </base-item-group>

              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-google-classroom</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                Digital Classroom
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in Subjects">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
              >
              </base-item-group>

              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template> -->
      <br />
       <!-- <template>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-icon>mdi-door-open</v-icon>
              <div v-show="drawer" style="margin-left: 15px; width: 100px">
                Academic Calender
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="(item, i) in Academic">
              <base-item-group
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
              >
              </base-item-group>

              <base-item v-else :key="`item-${i}`" :item="item" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template> -->

      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    authRolePermissionData:[],
    eLibrary: [
      {
        icon: "mdi-view-dashboard",
        title: "E-library",
        to: "/",
      },
    ],
    dashboard: [
      {
        icon: "mdi-view-dashboard",
        title: "dashboard",
        to: "/admin/",
      },
      // {
      // icon: 'mdi-view-dashboard',
      //   title: 'Institute Dashboard',
      //   to: '/admin/institute-admin',
      // },
    ],
    instituteItems: [
      {
        title: "Student List",
        icon: "mdi-application",
        to: "/admin/student-list",
      },
      {
        title: "Education Type",
        icon: "mdi-arrange-bring-forward",
        to: "/admin/education-type-new",
      },
    ],
    items: [
      // {
      //   title: 'E-content-Old',
      //   icon: 'mdi-application',
      //   to: '/e-content-list',
      // },
      {
        title: "E-content",
        icon: "mdi-application",
        to: "/admin/eContent",
      },
      //  {
      //   title: 'icons',
      //   icon: 'mdi-chart-bubble',
      //   to: '/admin/components/icons',
      // },
      //  {
      //   title: 'institute',
      //   icon: 'mdi-chart-bubble',
      //   to: '/admin/institute-list',
      // },
      {
        icon: "mdi-view-dashboard",
        title: "Content Type",
        to: "/admin/content-type-new",
      },
    ],
    portal: [
      {
        title: "Important Link",
        icon: "mdi-cog-outline",
        to: "/admin/portal-important-link",
      },
      {
        title: "Portal Content",
        icon: "mdi-cog-outline",
        to: "/admin/portal-content-list",
      },
      // {
      //   title: 'Notice',
      //   icon: 'mdi-application',
      //   to: '/admin/portal-notice',
      // },
      // {
      //   title: 'Blog',
      //   icon: 'mdi-application',
      //   to: '/admin/blog-list',
      // },
      {
        title: "Faq",
        icon: "mdi-application",
        to: "/admin/faq",
      },
      {
        title: "Blog",
        icon: "mdi-application",
        to: "/admin/blog",
      },
      {
        title: "Notice",
        icon: "mdi-application",
        to: "/admin/notice",
      },
    ],
    settings: [
      {
        title: "Division",
        icon: "mdi-arrange-bring-forward",
        to: "/admin/division-new",
      },
      {
        title: "District",
        icon: "mdi-arrange-bring-forward",
        to: "/admin/district-new",
      },
      {
        title: "Thana",
        icon: "mdi-arrange-bring-forward",
        to: "/admin/thana-new",
      },
      {
        title: "Post Office",
        icon: "mdi-arrange-bring-forward",

        to: "/admin/post-office-new",
      },
      {
        title: "Subject",
        icon: "mdi-cog-outline",
        to: "/admin/subject",
      },
      {
        title: "Year",
        icon: "mdi-cog-outline",
        to: "/admin/year",
      },
      {
        title: "Department",
        icon: "mdi-cog-outline",
        to: "/admin/department-new",
      },
      {
        title: "Role",
        icon: "mdi-cog-outline",
        to: "/admin/role-new",
      },
      {
        title: "Designation",
        icon: "mdi-cog-outline",
        to: "/admin/designation-new",
      },
      {
        title: "Menu",
        icon: "mdi-cog-outline",
        to: "/admin/permission-list",
      },
      {
        title: "User Types",
        icon: "mdi-cog-outline",
        to: "/admin/user-type-list",
      },

      {
        title: "Sessions",
        icon: "mdi-cog-outline",
        to: "/admin/session-list",
      },
      {
        title: "Batch",
        icon: "mdi-cog-outline",
        to: "/admin/batch-list",
      },
      {
        title: "Section",
        icon: "mdi-cog-outline",
        to: "/admin/section-list",
      },
      {
        title: "Group",
        icon: "mdi-cog-outline",
        to: "/admin/group-list",
      },
      {
        title: "Institute Type",
        icon: "mdi-cog-outline",
        to: "/admin/institute-type-list",
      },
      {
        title: "Audit Trail",
        icon: "mdi-cog-outline",
        to: "/admin/audit-log-list",
      },
      {
        title: "Set User Permission",
        icon: "mdi-cog",
        to: "/admin/all-user-permission"
      }
    ],
    institute: [
      {
        title: "Institute",
        icon: "mdi-arrange-bring-forward",
        to: "/admin/institute-new",
      },
      {
        title: "Teacher",
        icon: "mdi-arrange-bring-forward",
        to: "/admin/teacher-new",
      },
      {
        title: "Student List",
        icon: "mdi-application",
        to: "/admin/student-list",
      },
      {
        title: "Education Type",
        icon: "mdi-application",
        to: "/admin/education-type-new",
      },
    ],

    Subjects: [
      {
        icon: "mdi-application",
        title: "Offered Subjects",
        to: "/admin/offered-subject",
      },
      {
        title: "Course Curriculum",
        icon: "mdi-application",
        to: "/admin/course-curriculum-list",
      },
    ],
      Academic: [
      {
        icon: "mdi-application",
        title: "Academic Calender",
        to: "/admin/academic-calender",
      },
    ],
  }),
  created() {
    // this.$store.dispatch("callPermissionData", {
    //   page: 1,
    //   size: -1,
    // });
    // this.$store.dispatch("callRolePermissionMenuData", {
    //   page: 1,
    //   size: -1,
    // });
    this.authRolePermissionData = JSON.parse(
      window.localStorage.getItem("authRolePermissionData")
    );
    let dashboardData = localStorage.getItem("thisDashboard");
    ////  console.log("dashboardData",dashboardData);
    this.dashboard[0].to = dashboardData;
  },

  computed: {
    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return {
        avatar: true,
        title: this.$t("avatar"),
      };
    },
    miniM: {
      get() {
        return !this.$store.state.drawer;
      },
      set() {},
    },
    getMenuData() {
      return this.$store.getters.getPermissionItem;
    },
    getPermissionMenuData() {
      return this.$store.getters.getRolePermissionMenuItem;
    },
    getUserType(){
      return JSON.parse(window.localStorage.getItem('currentUser'));
    }
  },
  //section for asynchronous data change
  watch: {
    miniM(val) {},
    getMenuData(val) {
    },
    getPermissionMenuData(val) {
      // this.createMenuStorageData(val);
    },
  },
  //section for my functions
  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      };
    },
    redirectToHome() {
      this.$router.push("/");
    },
    createMenuStorageData(item){
      item.role_permission.forEach((parD)=>{
        parD.child.forEach((cldD)=>{
          let data = JSON.stringify(cldD);
          window.localStorage.setItem(`${cldD.path}`, data);
        })
      })
    }
  },
};
</script>

<style>
.v-navigation-drawer--fixed {
  z-index: 15;
}
.fixIconPlace {
  margin-left: 10px;
}
.v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
  flex: none;
}
.v-list-item__title {
  height: 40px;
  padding-top: 13px;
}
</style>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .v-list-group__header.v-list-item--active:before
    opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
